import {
  FETCH_VALIDATE_OTP_REQUEST,
  FETCH_VALIDATE_OTP_SUCCESS,
  FETCH_VALIDATE_OTP_FALUIRE,
} from './validateOTPTypes'

const initialState = {
  loading: false,
  validateOTPInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_VALIDATE_OTP_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_VALIDATE_OTP_SUCCESS : return {
      ...state,
      validateOTPInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_VALIDATE_OTP_FALUIRE : return {
      ...state,
      loading: false,
      validateOTPInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
